module.exports = __webpack_public_path__ + "static/media/Foto.fc1fb4b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_archiv/thumb/Foto.jpg
// module id = 582
// module chunks = 0